class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    
    const searchIcon = this.parentElement.querySelector('.show-search-link')
    // const searchIconMobile = this.parentElement.querySelector('.show-search-link.mobile-only')
    const searchBar = this.parentElement.querySelector('#Search')
    const searchBarMobile = this.parentElement.querySelector('predictive-search')

    searchIcon.addEventListener('click', function(){
      searchBar.focus()
      if (window.innerWidth <= 767){
        searchBarMobile.classList.toggle('active')
      }
    })
    // searchIconMobile.addEventListener('click', function(){
    //   searchBarMobile.classList.toggle('active')
    //   if(searchBarMobile.classList.contains('active')){
    //     searchBar.focus()
    //   }
    // })
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';

  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
